import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import ReactSVG from 'react-svg'
import { getFormattedAdPrice } from 'SRC/utils'
import useTranslation from 'next-translate/useTranslation'
import { connect } from 'react-redux'
import { getInfo } from 'SRC/modules/users/detail/selectors'
import { SendRequestButton } from '../SendRequestButton'
import { getOrderForm, getVehiclePart, getDeliveryInfo } from '../../selectors'
import { Photos } from '../Photos'
import { CallButton } from '../CallButton'

const ProductSummary = ({
	vehiclePart: {
		img_path,
		name,
		tire_season_slug,
		product_code,
		availableQuantity,
		price,
		discounted_price,
		show_discount,
		discount,
		image_tags
	},
	submit,
	orderForm,
	user,
	deliveryInfo
}) => {
	const { t, lang } = useTranslation('common')

	const router = useRouter()

	const userPhone = Array.isArray(user?.phones) ? user.phones.find(phone => phone.visible) : null

	const images = Array.isArray(img_path)
		? img_path.map((image, index) => ({ id: index + 1, src: `https://slikeprodavnica.autodiler.me/original${image.img}` }))
		: []

	return (
		<section className='vehicle-part-product-summary'>
			<Photos images={images} deliveryInfo={deliveryInfo} imageTags={image_tags} />

			<div className='vehicle-part-product-summary__product-info'>
				<h3 className='vehicle-part-product-summary__product-info-title'>
					{tire_season_slug?.slug === 'zimska' ? (
						<ReactSVG src={`/icons/guma-zimska.svg`} className='vehicle-part-product-summary__product-info-title-icon__wrapper' beforeInjection={(svg) => {
							svg.setAttribute('width', '23px')
							svg.setAttribute('height', '25px')
						}} />
					) : null}

					{tire_season_slug?.slug === 'ljetnja' ? (
						<ReactSVG src={`/icons/guma-ljetnja.svg`} className='vehicle-part-product-summary__product-info-title-icon__wrapper' beforeInjection={(svg) => {
							svg.setAttribute('width', '23px')
							svg.setAttribute('height', '25px')
						}} />
					) : null}

					{tire_season_slug?.slug === 'all-season' ? (
						<ReactSVG src={`/icons/guma-univerzalna.svg`} className='vehicle-part-product-summary__product-info-title-icon__wrapper' beforeInjection={(svg) => {
							svg.setAttribute('width', '23px')
							svg.setAttribute('height', '25px')
						}} />
					) : null}

					{name?.name}
				</h3>

				<div className='vehicle-part-product-summary__product-info-code-amount'>
					{availableQuantity?.text ? (
						<p
							className='vehicle-part-product-summary__product-info-code-amount__amount'
							style={{ backgroundColor: availableQuantity?.color }}
						>
							<span className='vehicle-part-product-summary__product-info-code-amount__amount-circle' />
							<span>
								{availableQuantity?.text}
							</span>
						</p>
					) : null}
					<p className='vehicle-part-product-summary__product-info-code-amount__code'>{`${t('sifraArtikla')}: ${product_code}`}</p>
				</div>

				<div className='vehicle-part-product-summary__product-info-price'>
					<div
						className='vehicle-part-product-summary__product-info-price-retail'
						style={{
							borderRight: discounted_price && show_discount ? 'none' : '1px solid #e7e7e7',
						}}
					>
						<p
							className='vehicle-part-product-summary__product-info-price-retail-value'
							style={{
								color: discounted_price && show_discount ? '#bbb' : '#e90000',
								textDecoration: discounted_price && show_discount ? 'line-through' : 'none',
								textDecorationThickness: '2px'
							}}
						>
							{getFormattedAdPrice(price)} &euro;
						</p>
						<p className='vehicle-part-product-summary__product-info-price-retail-text'>{t('Maloprodajna cijena')}</p>
					</div>

					{discounted_price && show_discount ? (
						<>
							<div className='vehicle-part-product-summary__product-info-price-discounted'>
								<p className='vehicle-part-product-summary__product-info-price-discounted-value'>{getFormattedAdPrice(discounted_price)} &euro;</p>
								<p className='vehicle-part-product-summary__product-info-price-discounted-text'>{t('Cijena sa popustom')}</p>
							</div>

							<div className='vehicle-part-product-summary__product-info-price-saving'>
								<p className='vehicle-part-product-summary__product-info-price-saving-value'>{`${t('Ušteda')} ${getFormattedAdPrice(price - discounted_price)}`} &euro;</p>
								<p className='vehicle-part-product-summary__product-info-price-saving-text'>{t('za jednokratno plaćanje')}</p>
							</div>
						</>
					) : null}
				</div>


				<div className='vehicle-part-product-summary__product-info-buttons'>
					<SendRequestButton onClick={submit} title={orderForm?.mainHeader || t('vehicle_parts_send_request')} />
					{userPhone?.phone ? <CallButton phone={userPhone.phone} /> : null}
				</div>
			</div>
		</section>
	)
}

ProductSummary.propTypes = {
	vehiclePart: PropTypes.shape({
		ean: PropTypes.string.isRequired,
		price: PropTypes.number.isRequired,
		discounted_price: PropTypes.number.isRequired,
		discount: PropTypes.number.isRequired,
		show_discount: PropTypes.bool.isRequired,
		name: PropTypes.shape({
			name: PropTypes.string.isRequired,
			slug: PropTypes.string.isRequired,
		}).isRequired,
		product_code: PropTypes.string.isRequired,
		img_path: PropTypes.string.isRequired,
		availability: PropTypes.shape({
			name: PropTypes.string.isRequired,
			color: PropTypes.string.isRequired
		}).isRequired,
	}).isRequired,
	submit: PropTypes.func.isRequired,
	orderForm: PropTypes.shape({
		mainHeader: PropTypes.string.isRequired,
	}).isRequired,
}

ProductSummary.displayName = 'VehiclePartHeader'

const mapStateToProps = state => {
	return {
		vehiclePart: getVehiclePart(state),
		orderForm: getOrderForm(state),
		deliveryInfo: getDeliveryInfo(state),
		user: getInfo(state),
	}
}

export default connect(mapStateToProps)(ProductSummary)
